import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebase";
import { ROLE } from "../components/constant";
import { ACCESS } from "../components/constant";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userDoc, setUserDoc] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    return onAuthStateChanged(auth, (fbUser) => {
      console.log(fbUser, "fbUser in auth provider");
      setUser(fbUser);
      setLoaded(false);
    });
  }, []);

  useEffect(() => {
    if (!user) return;
    return onSnapshot(doc(db, "users", user.uid), (snap) => {
      setUserDoc(snap.data() || null);
      setLoaded(true);
    });
  }, [user]);

  const value = useMemo(() => {
    const role = userDoc?.role || null;
    console.log(role, "role in auth provider");
    const access = userDoc?.access || [];
    console.log(access, "access in auth provider");
    const isAdmin = role === ROLE.ADMIN;

    return {
      user,
      loaded,
      role,
      access,
      isAdmin,
      userDetails: userDoc && {
        firstName: userDoc.firstName || "",
        lastName: userDoc.lastName || "",
        email: userDoc.email || user?.email || "",
        companyName: userDoc.client?.companyName || "",
      },
      can: (flag) => {
        console.log(flag, "flag in auth provider");
        if (!flag || isAdmin) return true;
        if (flag === ACCESS.DASHBOARD) {
          return (
            access.includes(ACCESS.MRO_REPORT) || access.includes(ACCESS.REPORT)
          );
        }
        return access.includes(flag);
      },
    };
  }, [user, userDoc, loaded]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
